<template>
    <modal size="md" class="SelectAnalyticsPropertyModal" @close="close">
        <div class="text-center">
            <h3>Vælg en Analytics ejendom</h3>

            <form @submit.prevent="update">
                <div class="m-xl">
                    <form-item field="resource_id" :form="form" class="form-group-lg">
                        <label class="control-label">Ejendom</label>
                        <select v-model="form.resource_id" class="form-control input-lg" autofocus>
                            <option :value="null">
                                Vælg fra listen
                            </option>
                            <option
                                v-for="resource in validResources"
                                :key="resource.id"
                                :value="resource.views[0].id"
                            >
                                {{ resource.url }} ({{ resource.views[0].name }})
                            </option>
                        </select>
                    </form-item>
                </div>
                <button type="submit" class="btn btn-xl btn-success btn-load" :disabled="form.busy">
                    Vælg ejendom
                </button>
            </form>
        </div>
    </modal>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.SelectAnalyticsPropertyModal {
}
</style>
<script type="text/babel">
export default {
    props: ['channel'],

    data() {
        return {
            form: new SparkForm({
                resource_id: this.channel.resource_id,
            }),
        }
    },

    computed: {
        validResources() {
            return this.channel.resources.filter(resource => resource.views.length > 0)
        },
    },

    methods: {
        update() {
            Spark.put(route('api.channel.update', this.channel.id), this.form).then(this.close)
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>
